module.exports = __webpack_public_path__ + "images/9ed6615f.png";